import { ChangeDetectorRef, Component, EventEmitter, Inject, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import * as loginSelectors from './..../../../../../root-store/login-store/login.selector';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Validators } from '@angular/forms';
import { BsFileUploadNewComponent } from '@app/modules/bs-file-upload-new/bs-file-upload-new.component';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FileUploadService } from '@app/shared/services/file-upload/file-upload.service';
import { UserConnectionService, UserService } from '@app/shared/services';
import { InviteService } from '.././../../shared/services/invite/invite.service';
import moment from 'moment';
import { LoginStoreEffects } from '../../../root-store/login-store/effects';
import { SharedVaultService } from '@app/shared/services/vault/shared-vault.service';
import { EVENTS } from '@app/constants/events.constants';
import { relationshipStoreActions } from '@app/root-store';
import { Router } from '@angular/router';
import { UserTypeEnum } from '@app/enum/UserTypeEnum';
import { VaultStoreEffects } from '@app/root-store/vault-store/effects';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'add-connection-component',
  templateUrl: './add-connection.component.html',
})
export class AddConnectionComponent implements OnInit, OnDestroy {
  user$;
  connectionForm: FormGroup;
  format = null;
  imageChangedEvent = '';
  subscription = new Subscription();
  isPendingImg = false;
  pendingImgSrc = '';
  id = '';
  hideText = undefined;
  relationshipId;
  relationshipType;
  connection_relationship_data: any = {};
  selectedRelationship = {
    id: 68,
    name: 'Client',
  };
  isImpersonating = true;
  today = new Date();
  @Output() connectionCreated = new EventEmitter();
  @ViewChild('dp') datePicker;
  moment = moment;
  hasGuardianAccess = false;
  currentUser = undefined;
  isCreatingConnectionLoading = false;
  personalVaults: any[] | undefined;

  constructor(
    private store: Store,
    private fb: FormBuilder,
    private cd: ChangeDetectorRef,
    private toastr: ToastrService,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<AddConnectionComponent>,
    private fileUploadService: FileUploadService,
    private userService: UserService,
    private graphqlService: UserConnectionService,
    private inviteService: InviteService,
    private loginService: LoginStoreEffects,
    private sharedVaultService: SharedVaultService,
    private userConnectionService: UserConnectionService,
    private vaultService$: VaultStoreEffects,
    private router: Router
  ) {}
  ngOnInit(): void {
    this.user$ = this.store.select(loginSelectors.getCurrentUserDetailsAll);
    this.subscription.add(
      this.store.select(loginSelectors.getCurrentUserDetailsAll).subscribe((res) => {
        this.id = res?.id;
        this.currentUser = res;
      })
    );

    this.subscription.add(
      this.loginService.loginObject.subscribe((state) => {
        if (state?.data?.id) {
          const user = state.data;
          // if (user?.userLicense?.license_type == 'family' || user.user_type == UserTypeEnum.Professional) {
          this.hasGuardianAccess = true;
          this.connectionForm = this.fb.group({
            first_name: ['', [Validators.required, noWhitespaceValidator()]],
            last_name: ['', [Validators.required, noWhitespaceValidator()]],
            dateOfBirth: [''],
            relationship_type: [user.user_type === 'Professional' && !this.router.url.includes('professional') ? 'Client' : '', []],
            your_self: [''],
            has_passed_away: ['Yes', [Validators.required]],
            has_passed_away_date: [''],
          });

          if (this.data?.prefillData) {
            this.connectionForm.patchValue({
              first_name: this.data.prefillData.first_name || '',
              last_name: this.data.prefillData.last_name || '',
            });
          }

          if (
            user.user_type === 'Professional' &&
            !this.router.url.includes('professional') &&
            (!this.data?.custom_user_type || this.data.custom_user_type !== UserTypeEnum.Professional)
          ) {
            this.connection_relationship_data = {
              user: {
                relationship_name: 'Client',
              },
            };
            this.relationshipId = 68;
            this.relationshipType = 'Client';
          }
          // console.log({ user, data: this.data });
          if (this.data?.userDetails) {
            this.connectionForm.patchValue({
              first_name: this.data.userDetails.first_name || '',
              last_name: this.data.userDetails.last_name || '',
              dateOfBirth: this.data.userDetails.birthdate || '',
              relationship_type: this.data.userDetails.relationship_type || '',
              your_self: this.data.userDetails.your_self || '',
              has_passed_away: this.data.userDetails?.has_passed_away === true ? 'No' : 'Yes',
              has_passed_away_date: this.data.userDetails?.has_passed_away_date || '',
            });
            this.pendingImgSrc = this.data.userDetails?.profile_image_url;
          }
          // } else {
          //   this.hasGuardianAccess = false;
          //   this.connectionForm = this.fb.group({
          //     full_name: ['', [Validators.required, noWhitespaceValidator()]],
          //     email: ['', [Validators.required, FormValidator.email, noWhitespaceValidator()]],
          //     relationship_type: ['', [Validators.required]],
          //     dateOfBirth: ['', [Validators.required]],
          //   });
          // }
        }
      })
    );
    this.subscription.add(
      this.vaultService$.vaultObject.subscribe((state) => {
        const personal_vault = (state?.vaults || []).filter((v: any) => v.type === 'personal');
        this.personalVaults = personal_vault;
      })
    );
  }
  fileChangeEvent(event: any): void {
    const file = event.target.files && event.target.files[0];
    const extension = file.name.split('.').pop();
    if (file) {
      if (file.type.indexOf('image') > -1) {
        this.format = 'image';
        this.imageChangedEvent = event;
        this.cd.markForCheck();
      } else if (file.type.indexOf('video') > -1) {
        this.format = 'video';
        this.toastr.error('Invalid image type.');
      }

      if (file.type.indexOf('image') > -1) {
        const modalRef2 = this.dialog.open(BsFileUploadNewComponent, {
          data: {
            videoMimeType: file.type,
            format: this.format,
            type: 'guardian',
            title: 'Upload Guardian Profile Picture',
            image: 'profile',
            guardianId: 'noId',
            imageChangedEvent: this.imageChangedEvent,
            extension,
          },
          autoFocus: false,
          panelClass: 'full-window-dialog-2',
        });

        this.subscription.add(
          modalRef2.afterClosed().subscribe(async (upload_promise: any) => {
            const res = await upload_promise;
            if (res !== 'noId') {
              //  this.getGuardianUserDetails(this.connectionForm.controls['id'].value);
            } else {
              this.isPendingImg = true;
              const { file: gurFIle } = JSON.parse(localStorage.getItem('guardianImageToBeUploaded'));
              this.pendingImgSrc = gurFIle;
              this.toastr.success(`Image added`);
              this.cd.detectChanges();
            }
          })
        );
      }
    }
  }
  openImageUploadDialog() {}
  submitForm() {
    this.createGuardianUser();
  }
  public doSomething(data: any): void {
    if (data.id && data.name) {
      this.relationshipId = data.id;
      this.relationshipType = data.name;
      this.connectionForm.controls['relationship_type'].setValue(data.name);
      this.cd.detectChanges();
    }
    if (data.invalid) {
      this.connectionForm.controls['relationship_type'].setValue('');
    }
  }
  async addGuardianPic(id) {
    const file = JSON.parse(localStorage.getItem('guardianImageToBeUploaded'));
    const fd = { ...file, user_id: id };
    await new Promise((resolve, reject) => {
      this.subscription.add(
        this.fileUploadService.guardianImage(fd).subscribe(
          (res) => {
            // Remove the file from localStorage after successful upload
            localStorage.removeItem('guardianImageToBeUploaded');
            this.cd.detectChanges();
            resolve(res);
          },
          (error) => {
            console.error('Error uploading guardian image:', error);
            reject(error);
          }
        )
      );
    });
  }
  spouseList = ['Husband', 'Wife', 'Spouse', 'Fiancee', 'Civil Partner', 'Domestic Partner'];
  createGuardianUser() {
    // if  isManageGuardian i.e this.data.isManageGuardian ... Handle appropriately
    const passedAwayDate = this.connectionForm.controls['has_passed_away_date'].value;
    const formattedPassedAwayDate = passedAwayDate ? moment(passedAwayDate).format('YYYY-MM-DD') : '';
    const gPayload = {
      ...this.connectionForm.value,
      guardian_user_id: this.id,
      birthdate: moment(this.connectionForm.controls['dateOfBirth'].value).format('YYYY-MM-DD'),
      has_passed_away: this.connectionForm.controls['has_passed_away'].value === 'No',
      has_passed_away_date:
        this.connectionForm.controls['has_passed_away'].value === 'No'
          ? formattedPassedAwayDate === 'Invalid date'
            ? ''
            : formattedPassedAwayDate
          : null,
    };
    !gPayload.your_self || gPayload.your_self?.trim() === '' ? (gPayload.your_self = null) : '';
    delete gPayload.dateOfBirth;
    if (gPayload.birthdate === 'Invalid date') {
      gPayload.birthdate = '';
    }
    const isSpouse = this.spouseList.includes(this.connectionForm.controls['relationship_type'].value);
    if (this.connectionForm.valid) {
      if (this.hasGuardianAccess) {
        this.isCreatingConnectionLoading = true;
        this.subscription.add(
          this.userService
            .addGuardianUser({ ...gPayload, relationship_name: gPayload.relationship_type, user_type: this.data.custom_user_type })
            .subscribe({
              next: async (res) => {
                if (!!res && res?.id) {
                  res.relationship_name = gPayload.relationship_type;
                  const payload = {
                    from_user_id: this.id,
                    relationship_id: this.relationshipId,
                    requested_user_id: res?.id,
                    status: 'approved',
                  };

                  if (this.isPendingImg === true) {
                    this.addGuardianPic(res.id).then(() => {
                      setTimeout(async () => {
                        await this.connectUser(payload);
                      }, 500);
                    });
                  } else {
                    await this.connectUser(payload);
                  }
                  if (isSpouse) {
                    this.createVault({ ...gPayload, ...res });
                  }
                  // this.store.dispatch(new relationshipStoreActions.AllRelationships());
                  if (this.data.fromAddVault || this.data.fromSharing) {
                    this.dialogRef.close(res);
                  } else {
                    this.connectionCreated.emit(res);
                  }
                } else if (this.isCreatingConnectionLoading && !res?.id) {
                  this.isCreatingConnectionLoading = false;
                }

                this.cd.detectChanges();
              },
            })
        );
      } else {
        const createUserData = {
          ...this.connectionForm.value,
          relationship_id: this.relationshipId,
          relationship_name: this.connectionForm.controls['relationship_type'].value,
          to_name: this.connectionForm.controls['full_name'].value,
          user_id: gPayload.guardian_user_id,
          user_type: this.data.custom_user_type,
        };
        this.subscription.add(
          this.inviteService.createInvite(createUserData).subscribe({
            next: (res) => {
              this.isCreatingConnectionLoading = true;

              if (res?.guidance_status) {
                const payload = {
                  from_user_id: this.id,
                  relationship_id: this.relationshipId,
                  requested_user_id: res?.id,
                  status: 'approved',
                };

                if (this.isPendingImg === true) {
                  this.addGuardianPic(res.id).then(() => {
                    setTimeout(() => {
                      this.connectUser(payload);
                    }, 600);
                  });
                } else {
                  this.connectUser(payload);
                }

                if (this.data.fromSharing) {
                  this.store.dispatch(new relationshipStoreActions.AllRelationships());
                  this.dialogRef.close(res);
                } else {
                  this.connectionCreated.emit(res);
                }
              }
              this.cd.detectChanges();
            },
          })
        );
      }
    }
  }
  connectUser(payload) {
    return new Promise((resolve, reject) => {
      this.subscription.add(
        this.graphqlService.connectToUser(payload).subscribe({
          next: async (res) => {
            try {
              const p = await res;
              if (p) {
                // finalize success path immediately without delay
                this.subscription.add(this.graphqlService.getConnections().subscribe(() => {}));
                this.connectionForm.reset();
                this.pendingImgSrc = null;
                this.isCreatingConnectionLoading = false;
                this.toastr.success(
                  `New ${this.data?.custom_user_type?.toLowerCase() == 'professional' ? 'professional' : 'family'} account created`
                );
                this.trackEventsInMixPanel();
                if (!this.data.fromSharing && !this.data.fromAddVault) {
                  this.dialogRef.close(p);
                }
                this.cd.detectChanges();
              }
              if (p?.connection_status === 'pending') {
                this.connectionForm.reset();
                this.isCreatingConnectionLoading = false;
                this.toastr.success(
                  `New ${this.data?.custom_user_type?.toLowerCase() == 'professional' ? 'professional' : 'family'} account created`
                );
                if (!this.data.fromSharing) {
                  this.isCreatingConnectionLoading = false;
                  this.dialogRef.close(p);
                }
                this.cd.detectChanges();
              }
              resolve(null);
            } catch (error) {
              console.error('Error in connectUser:', error);
              this.isCreatingConnectionLoading = false;
              this.cd.detectChanges();
              reject(error);
            }
          },
          error: (error) => {
            console.error('Error connecting user:', error);
            this.isCreatingConnectionLoading = false;
            this.cd.detectChanges();
            reject(error);
          },
        })
      );
    });
  }
  editGuardian() {
    const passedAwayDate = this.connectionForm.controls['has_passed_away_date'].value;
    const formattedPassedAwayDate = passedAwayDate ? moment(passedAwayDate).format('YYYY-MM-DD') : '';
    const gPayload = {
      ...this.connectionForm.value,
      id: this.data.userDetails.id,
      birthdate: moment(this.connectionForm.controls['dateOfBirth'].value).format('YYYY-MM-DD'),
      relationship_type: this.relationshipType,
      has_passed_away: this.connectionForm.controls['has_passed_away'].value === 'No',
      has_passed_away_date:
        this.connectionForm.controls['has_passed_away'].value === 'No'
          ? formattedPassedAwayDate === 'Invalid date'
            ? ''
            : formattedPassedAwayDate
          : null,
    };
    !gPayload.your_self || gPayload.your_self?.trim() === '' ? (gPayload.your_self = null) : '';
    delete gPayload.dateOfBirth;
    if (gPayload.birthdate === 'Invalid date') {
      gPayload.birthdate = '';
    }
    const payload = {
      to_user_id: gPayload.id,
      from_user_id: this.data.userDetails.from_user_id,
      relationship_id: this.relationshipId,
      status: 'approved',
    };
    const finaldata = {
      to_user_id: this.data.userDetails.id,
      from_user_id: this.data.userDetails.from_user_id,
      status: 'approved',
      relationship_name: this.connectionForm.controls['relationship_type'].value || '',
      relationship_id: this.relationshipId,
    };
    if (!this.connectionForm.valid) {
      return;
    }
    this.subscription.add(
      this.userService.updateGuardianUser(gPayload).subscribe((res) => {
        if (!res) {
          return;
        }
        if (this.isPendingImg) {
          this.addGuardianPic(this.data.userDetails.id).then(() => {
            setTimeout(() => {
              this.store.dispatch(new relationshipStoreActions.AllRelationships());
              this.dialog.closeAll();
            }, 600);
          });
        } else if (this.connectionForm.controls['relationship_type'].value !== this.data.userDetails.relationship_name) {
          this.subscription.add(
            this.userConnectionService.userConnectionUpdate(payload).subscribe(() => {
              setTimeout(() => {
                this.store.dispatch(new relationshipStoreActions.AllRelationships());
                this.dialog.closeAll();
              }, 600);
            })
          );
          this.subscription.add(this.userConnectionService.sendRelationshipUpdateNotification(finaldata).subscribe());
          const isSpouse = this.spouseList.includes(this.connectionForm.controls['relationship_type'].value);
          if (isSpouse) {
            this.createVault(gPayload);
          }
        } else {
          this.store.dispatch(new relationshipStoreActions.AllRelationships());
          this.dialog.closeAll();
        }
      })
    );
  }

  onAliveStatusChange(event: any) {
    const selectedValue = event.value;
    if (selectedValue === 'Yes') {
      this.connectionForm.controls['has_passed_away_date'].setValue('');
      this.connectionForm.controls['has_passed_away_date'].clearValidators();
      this.connectionForm.controls['has_passed_away_date'].setErrors(null);
    } else {
      this.connectionForm.controls['has_passed_away_date'].setValidators([Validators.required]);
    }
    this.connectionForm.controls['has_passed_away_date'].updateValueAndValidity();
    this.cd.detectChanges();
  }

  logDateOfPassing(value) {
    this.connectionForm.controls['has_passed_away_date'].setValue(value);
    this.cd.detectChanges();
  }

  onMenuClosed() {
    this.relationshipId = null;
    this.relationshipType = null;
  }
  relationshipIdChanged() {}
  handleTabFix(event: any) {
    if (event.key === 'Tab' || event.code === 'Tab') {
      event.preventDefault();
      event.stopPropagation();
    }
  }
  closeDialog() {
    this.dialogRef.close();
  }
  logDate(value) {
    this.connectionForm.controls['dateOfBirth'].setValue(value);
    this.cd.detectChanges();
    this.datePicker.close();
    this.cd.detectChanges();
  }

  logDate2(value) {
    this.connectionForm.controls['dateOfBirth'].setValue(value);
    this.cd.detectChanges();
    this.datePicker.close();
    this.cd.detectChanges();
  }

  ngOnDestroy() {
    this.isCreatingConnectionLoading = false;
    this.subscription?.unsubscribe();
    this.userService.cleanupWorker();
  }
  createSharedVault(member) {
    const members = {
      name: member?.nick_name ?? member?.user_first_name,
      user_id: member?.id as any,
      type: 'member' as 'member',
    };
    const payload = {
      user_id: this.currentUser.id as any,
      name: `${this.currentUser?.nick_name ?? this.currentUser.first_name}`,
      member: [members],
    };
    this.subscription.add(this.sharedVaultService.createSharedVault(payload).subscribe(() => {}));
  }

  trackEventsInMixPanel() {
    const events =
      this.data.type === 'Immediate Family Members'
        ? [{ eventName: EVENTS.network_setup_immediate_family_add_change }]
        : this.data.type === 'In-Laws'
        ? [{ eventName: EVENTS.network_setup_in_laws_add_change }]
        : this.data.type === 'Extended Family Members'
        ? [{ eventName: EVENTS.network_setup_extended_family_add_change }]
        : this.data.type === 'Other Relationships'
        ? [{ eventName: EVENTS.network_setup_other_relationship_add_change }]
        : this.data.type === 'Service Providers'
        ? [{ eventName: EVENTS.network_setup_service_providers_add_change }]
        : this.data.type === 'Staff'
        ? [{ eventName: EVENTS.network_setup_staff_add_change }]
        : [];
    this.userService.trackEventsInMixPanel(events).then(() => {});
  }

  createVault(gPayload) {
    const userId = gPayload?.id ?? gPayload?.userId;
    const userName = gPayload?.first_name ?? gPayload?.first_middle_name ?? gPayload?.nick_name;

    const members = {
      name: userName,
      user_id: userId as any,
      type: 'member' as 'member',
    };
    const allVaultNames = this.personalVaults.map((v) => v.name);
    const vaultMembers = [
      {
        user_first_name: this.currentUser?.first_name ?? this.currentUser?.first_middle_name,
        user_id: this.currentUser?.id ?? this.currentUser?.user_id,
        type: 'owner',
      },
      {
        user_first_name: userName,
        user_id: gPayload?.id,
      },
    ];

    const baseName = this.formatVaultName(vaultMembers);
    const vaultName = this.generateUniqueVaultName(baseName, allVaultNames);

    const sharedPayload = {
      user_id: this.currentUser?.id as any,
      name: vaultName,
      member: [members],
    };

    const payload = {
      name: vaultName ?? 'Untitled Vault',
      type: 'personal',
      user_id: this.currentUser?.id ?? this.currentUser?.user_id,
      member: vaultMembers,
      url: '/vault',
    };

    const matching = allVaultNames.filter((name) => name === baseName || name.startsWith(baseName + ' '));
    if (matching.length === 0) {
      this.subscription.add(
        this.sharedVaultService.createVault(payload).subscribe(
          async (data) => {
            if (data) {
              this.subscription.add(
                this.sharedVaultService.createSharedVault(sharedPayload).subscribe(
                  () => {
                    // Shared vault created successfully
                  },
                  (err) => {
                    console.error('Error creating shared vault:', err);
                  }
                )
              );
            }
          },
          (error: any) => {}
        )
      );
    }
  }
  formatVaultName(users) {
    const names = users.map((user) => user?.user_first_name || user?.first_name);
    if (names.length === 0) return '';
    if (names.length === 1) return names[0];
    if (names.length === 2) return names.join(' & ');

    // For more than 2 names, join with a comma, except for the last one
    return `${names.slice(0, -1).join(', ')}, & ${names[names.length - 1]}`;
  }
  generateUniqueVaultName(baseName: string, existingVaultNames: string[]): string {
    // get names that start with the same base name
    const matching = existingVaultNames.filter((name) => name === baseName || name.startsWith(baseName + ' '));
    if (matching.length === 0) {
      return baseName;
    }
    // extract numeric suffixes
    const counts = matching.map((name) => {
      const parts = name.replace(baseName, '').trim(); // get suffix e.g. "2"
      const num = parseInt(parts);
      return isNaN(num) ? 1 : num;
    });

    const max = Math.max(...counts);
    return `${baseName} ${max + 1}`;
  }
}

export function noWhitespaceValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const isWhitespace = (control.value || '').trim().length === 0;
    return isWhitespace ? { whitespace: true } : null;
  };
}
